import { companyInfo } from '../../../components/companyInfo';
import { useNavigate } from 'react-router-dom';
// Configuration constants
export const INTERNET_PACKAGES = [
  { id: 'package_50', name: '2GB - 2 Days', price: 50, data: '2GB', duration: '2 days' },
  { id: 'package_100', name: '3GB - 3 Days', price: 100, data: '3GB', duration: '3 days' },
  { id: 'package_650', name: '10GB - 1 Month', price: 650, data: '10GB', duration: '1 month' }
];

export const POLLING_CONFIG = {
  maxPolls: 24, // 2 minutes with 5-second intervals
  pollInterval: 5000 // 5 seconds
};

// ==================== BUSINESS LOGIC HOOK ====================
export const useChatbotFunctions = (state, config) => {
  const {
    messages, setMessages,
    setIsLoading,
    setCurrentFlow,
    setSelectedPackage,
    setPaymentData,
    completedTransactions, setCompletedTransactions,
    checkoutRequestIds, setCheckoutRequestIds,
    currentFlow,
    selectedPackage,
    paymentData
  } = state;
   const navigate = useNavigate();
  // Add message helper
  const addMessage = (text, sender = 'bot', type = 'text', options = null, additionalData = {}) => {
    const message = {
      text,
      sender,
      timestamp: new Date().toISOString(),
      type,
      options,
      ...additionalData
    };
    setMessages(prev => [...prev, message]);
  };

  // Add completed transaction
  const addCompletedTransaction = (transaction) => {
    const completedTransaction = {
      id: Date.now(),
      ...transaction,
      completedAt: new Date().toISOString(),
      status: 'completed'
    };

    setCompletedTransactions(prev => {
      const updated = [completedTransaction, ...prev];
      return updated;
    });

    // Remove from pending checkout requests
    setCheckoutRequestIds(prev => {
      const updated = { ...prev };
      delete updated[transaction.checkoutRequestId];
      return updated;
    });
  };

  // Generate menu options
  const generateMenuOptions = () => {
    const menuOptions = [
      { id: 'internet', label: '📶 Sunshine WIFI', action: 'showInternetPackages' },
      {
    id: 'register',
    label: '📝 Student onboard',
    action: 'openRegistration'
  },
      { id: 'rent', label: '🏠 Rent Payment', action: 'showRentPayment' },
      { id: 'support', label: '💬 Customer Support', action: 'showSupport' }
    ];

    if (completedTransactions.length > 0) {
      menuOptions.splice(2, 0, { id: 'history', label: '📊 Transaction History', action: 'showTransactionHistory' });
    }
    
    return menuOptions;
  };

  // Handle menu actions
  const handleMenuAction = (action, data = {}) => {
    switch (action) {
      case 'showInternetPackages':
        setCurrentFlow('internet');
        addMessage("Choose your internet package:", 'bot', 'packages', INTERNET_PACKAGES);
        break;

      case 'showRentPayment':
        setCurrentFlow('rent');
        addMessage("Please enter the amount you'd like to pay for rent:", 'bot', 'input', null, {
          inputType: 'number',
          inputPlaceholder: 'Enter amount (KSH)',
          inputAction: 'processRentAmount'
        });
        break;

      case 'openRegistration':
        navigate('/auth/onboard/sunshine');
        
        break;

      case 'showSupport':
        setCurrentFlow('support');
        addMessage("I'm here to help! You can ask me about our services, contact information, or any other questions.", 'bot');
        break;

      case 'selectPackage':
        setSelectedPackage(data.package);
        setCurrentFlow('payment');
        addMessage(`You selected: ${data.package.name} - KSH ${data.package.price}`, 'user');
        addMessage("Please enter your account number:", 'bot', 'input', null, {
          inputType: 'text',
          inputPlaceholder: 'Your account number',
          inputAction: 'processInternetAccountNumber'
        });
        break;

      case 'processRentAmount':
        const amount = parseFloat(data.value);
        if (amount && amount > 0) {
          setPaymentData({ amount, service: 'rent' });
          addMessage(`Rent payment: KSH ${amount}`, 'user');
          addMessage("Please enter your account number:", 'bot', 'input', null, {
            inputType: 'text',
            inputPlaceholder: 'Your account number',
            inputAction: 'processRentAccountNumber'
          });
        } else {
          addMessage("Please enter a valid amount.", 'bot', 'error');
        }
        break;

      case 'processInternetAccountNumber':
        const internetAccountNumber = data.value.trim();
        if (internetAccountNumber) {
          setPaymentData({ ...paymentData, accountNumber: internetAccountNumber });
          addMessage(`Account Number: ${internetAccountNumber}`, 'user');
          addMessage("Please enter your phone number to proceed with payment:", 'bot', 'input', null, {
            inputType: 'tel',
            inputPlaceholder: '0712345678',
            inputAction: 'processInternetPayment'
          });
        } else {
          addMessage("Please enter a valid account number.", 'bot', 'error');
        }
        break;

      case 'processRentAccountNumber':
        const rentAccountNumber = data.value.trim();
        if (rentAccountNumber) {
          setPaymentData({ ...paymentData, accountNumber: rentAccountNumber });
          addMessage(`Account Number: ${rentAccountNumber}`, 'user');
          addMessage("Please enter your phone number to proceed with payment:", 'bot', 'input', null, {
            inputType: 'tel',
            inputPlaceholder: '0712345678',
            inputAction: 'processRentPayment'
          });
        } else {
          addMessage("Please enter a valid account number.", 'bot', 'error');
        }
        break;

      case 'processInternetPayment':
        processPayment(data.value, selectedPackage.price, paymentData.accountNumber, `Internet - ${selectedPackage.name}`);
        break;

      case 'processRentPayment':
        processPayment(data.value, paymentData.amount, paymentData.accountNumber, 'Rent Payment');
        break;

      case 'backToMain':
        setCurrentFlow('main');
        setSelectedPackage(null);
        setPaymentData({});
        addMessage("Please select a service", 'bot', 'menu', generateMenuOptions());
        break;

      case 'showTransactionHistory':
        if (completedTransactions.length === 0) {
          addMessage("You have no completed transactions yet.", 'bot');
          addMessage("Would you like to make a transaction?", 'bot', 'menu', [
            { id: 'internet', label: '📶 Internet Packages', action: 'showInternetPackages' },
            { id: 'rent', label: '🏠 Pay Rent', action: 'showRentPayment' },
            { id: 'main', label: '🏠 Back to Main Menu', action: 'backToMain' }
          ]);
        } else {
          addMessage("Your Transaction History:", 'bot', 'transactionHistory', completedTransactions.slice(0, 5));
        }
        break;

      default:
        break;
    }
  };

  // Payment processing
  const processPayment = async (phoneNumber, amount, accountReference, transactionDesc) => {
    // Validate phone number
    const cleanPhone = phoneNumber.replace(/\D/g, '');
    if (cleanPhone.length !== 10 && cleanPhone.length !== 12) {
      addMessage("Please enter a valid phone number (e.g., 0712345678)", 'bot', 'error');
      return;
    }

    // Format phone number
    let formattedPhone = cleanPhone;
    if (cleanPhone.length === 10 && cleanPhone.startsWith('0')) {
      formattedPhone = '254' + cleanPhone.substring(1);
    }

    addMessage(`Phone: ${phoneNumber}`, 'user');
    setIsLoading(true);

    try {
      const response = await fetch(`${config.apiBaseUrl}/stk-push/initiate/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          phone_number: formattedPhone,
          amount: amount,
          account_reference: accountReference,
          transaction_desc: transactionDesc
        })
      });

      const result = await response.json();

      if (response.ok && result.data) {
        const checkoutRequestId = result.data.checkout_request_id;
        setCheckoutRequestIds(prev => ({
          ...prev,
          [checkoutRequestId]: {
            phoneNumber: formattedPhone,
            amount,
            accountReference,
            transactionDesc,
            initiatedAt: new Date().toISOString()
          }
        }));

        addMessage(
          `✅ Payment request sent! Please check your phone and enter your M-Pesa PIN to complete the payment.\n\nAccount Number: ${accountReference}\nAmount: KSH ${amount}`,
          'bot',
          'success'
        );

        startTransactionPolling(checkoutRequestId);

      } else {
        throw new Error(result.message || 'Payment initiation failed');
      }
    } catch (error) {
      addMessage(
        `❌ Payment failed: ${error.message}. Please try again or contact support at 0725884205.`,
        'bot',
        'error'
      );

      addMessage("Would you like to try again?", 'bot', 'menu', [
        { id: 'retry', label: '🔄 Try Again', action: currentFlow === 'internet' ? 'showInternetPackages' : 'showRentPayment' },
        { id: 'main', label: '🏠 Back to Main Menu', action: 'backToMain' }
      ]);
    } finally {
      setIsLoading(false);
    }
  };

  // Transaction polling
const startTransactionPolling = (checkoutRequestId) => {
  let pollCount = 0;

  const poll = async () => {
    pollCount++;

    try {
      const response = await fetch(`${config.apiBaseUrl}/stk-push/status/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ checkout_request_id: checkoutRequestId })
      });

      const result = await response.json();

      if (response.ok && result.data) {
        const transaction = result.data;
        const pendingTransaction = checkoutRequestIds[checkoutRequestId];

        const resultCode = String(transaction.result_code || '');
        const transactionStatus = transaction.status?.toLowerCase();

        if (transactionStatus === 'processing' || transaction.result_desc?.includes('under processing')) {
          // Continue polling by scheduling next call
          if (pollCount < POLLING_CONFIG.maxPolls) {
            setTimeout(poll, POLLING_CONFIG.pollInterval);
          } else {
            addMessage('⏰ Payment status check timed out. Please check your transaction history later or contact support at 0725884205.', 'bot', 'warning');
          }
          return;
        }

        if (resultCode === '0' || transactionStatus === 'completed') {
          // Handle completed transaction
          const completedTransaction = {
            checkoutRequestId,
            ...pendingTransaction,
            amount: transaction.amount,
            account: transaction.account_reference,
            mpesaReceiptNumber: transaction.mpesa_receipt_number || 'N/A',
            transactionDate: transaction.transaction_date || new Date().toISOString(),
            resultCode: resultCode,
            status: 'completed'
          };

          addCompletedTransaction(completedTransaction);

         

          setTimeout(() => {
            addMessage(
            `🎉 Payment Successful!\nAmount: KSH ${completedTransaction?.amount}\nAccount: ${completedTransaction?.account}`,
            'bot',
            'success'
          );
          }, 2000);
          return;
        } else if (['cancelled', 'failed'].includes(transactionStatus) || ['1032', '1037', '1'].includes(resultCode)) {
          // Handle cancellation or failure
          setCheckoutRequestIds(prev => {
            const updated = { ...prev };
            delete updated[checkoutRequestId];
            return updated;
          });

          let statusMessage;
          if (resultCode === '1032' || transactionStatus === 'cancelled') {
            statusMessage = '❌ Payment was cancelled by user. Please try again if needed.';
          } else if (resultCode === '1037') {
            statusMessage = '❌ Payment request timed out. Please try again.';
          } else {
            statusMessage = `❌ Payment failed: ${transaction.result_desc || 'Unknown error'}`;
          }

          addMessage(statusMessage, 'bot', 'error');

          setTimeout(() => {
    addMessage("Please select a service", 'bot', 'menu', generateMenuOptions());
    setCurrentFlow('main');
  }, 2000);
          return;
        }

        if (pollCount >= POLLING_CONFIG.maxPolls) {
          addMessage('⏰ Payment status check timed out. Please check your transaction history later or contact support at 0725884205.', 'bot', 'warning');
          return;
        }
      }
    } catch (error) {

      if (pollCount >= POLLING_CONFIG.maxPolls) {
        addMessage('Unable to verify payment status. Please check your M-Pesa messages or contact support at 0725884205.', 'bot', 'error');
        return;
      }
    }

    // Schedule next poll if maxPolls not reached
    if (pollCount < POLLING_CONFIG.maxPolls) {
      setTimeout(poll, POLLING_CONFIG.pollInterval);
    }
  };

  poll(); // start polling immediately
};


  // Company info response
  const getCompanyInfoResponse = (query) => {
    const queryLower = query.toLowerCase();

    if (queryLower.includes('contact') || queryLower.includes('reach') || queryLower.includes('email') || queryLower.includes('phone')) {
      return `You can contact ${companyInfo.name} via:
Email: ${companyInfo.contactInfo.email}
Phone: ${companyInfo.contactInfo.phone}
Address: ${companyInfo.contactInfo.address}`;
    }

    if (queryLower.includes('hours') || queryLower.includes('open') || queryLower.includes('when') && queryLower.includes('available')) {
      return `Our business hours are: ${companyInfo.hours}`;
    }

    if (queryLower.includes('sijapata code') || queryLower.includes("haven't received") || queryLower.includes('nimelipa wifi') || queryLower.includes('I have paid')) {
      return `Sorry about that, Please respond with the mpesa reference number only.`;
    }

    if (queryLower.includes('about') || queryLower.includes('company')) {
      return `${companyInfo.name} is ${companyInfo.description}`;
    }

    if (companyInfo.faq && companyInfo.faq.length > 0) {
      for (const item of companyInfo.faq) {
        const questionKeywords = item.question.toLowerCase().split(' ').filter(word => word.length > 3);
        const matchCount = questionKeywords.filter(keyword => queryLower.includes(keyword)).length;

        if (matchCount > questionKeywords.length * 0.6) {
          return item.answer;
        }
      }
    }

    return null;
  };

  // Gemini API response
  const generateGeminiResponse = async (prompt) => {
    if (!config.apiKey) {
      return "API key is missing. Please provide a valid Gemini API key.";
    }

    const contextEnrichedPrompt = `As a customer service chatbot for ${companyInfo.name}, which is ${companyInfo.description}, please respond to the following customer query. 
    
Company information:
- Company Name: ${companyInfo.name}
- Contact Email: ${companyInfo.contactInfo.email}
- Contact Phone: ${companyInfo.contactInfo.phone}
- Business Hours: ${companyInfo.hours}
${companyInfo.services.length > 0 ? `- Services: ${JSON.stringify(companyInfo.services)}` : ''}
${companyInfo.faq.length > 0 ? `- FAQ: ${JSON.stringify(companyInfo.faq)}` : ''}

Customer query: ${prompt}

Please provide a helpful, and very brief response based on the company information. If you don't know the answer, suggest they contact us directly.`;

    const endpoint = "https://generativelanguage.googleapis.com/v1beta/models/gemini-2.0-flash:generateContent";

    try {
      const response = await fetch(`${endpoint}?key=${config.apiKey}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          contents: [{
            parts: [{
              text: contextEnrichedPrompt
            }]
          }]
        })
      });

      if (!response.ok) {
        throw new Error(`API request failed with status ${response.status}`);
      }

      const data = await response.json();
      return data.candidates[0].content.parts[0].text;
    } catch (error) {
      throw error;
    }
  };

  // Send message function
  const sendMessage = async (inputText, setInputText) => {
    if (!inputText.trim()) return;

    const userMessage = {
      text: inputText,
      sender: 'user',
      timestamp: new Date().toISOString(),
      type: 'text'
    };

    setMessages(prev => [...prev, userMessage]);
    setInputText('');
    setIsLoading(true);

    try {
      const companyResponse = getCompanyInfoResponse(inputText);
      let responseText;

      if (companyResponse) {
        responseText = companyResponse;
      } else {
        responseText = await generateGeminiResponse(inputText);
      }

      const botMessage = {
        text: responseText,
        sender: 'bot',
        timestamp: new Date().toISOString(),
        type: 'text'
      };

      setMessages(prev => [...prev, botMessage]);
    } catch (error) {

      const errorMessage = {
        text: "I'm currently unavailable, please call 0725884205 to speak to a human.",
        sender: 'bot',
        timestamp: new Date().toISOString(),
        type: 'error'
      };

      setMessages(prev => [...prev, errorMessage]);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    addMessage,
    handleMenuAction,
    sendMessage,
    generateMenuOptions
  };
};